
import { ActionTree } from 'vuex';
import { ConditionCategoryState } from './types';
import { RootState } from '../../types';
import { defaultBackendConditionCategory } from '@/shared/backend/conditionCategory';
import { Logger } from 'fsts';
import module_utils from '../module_utils';
import conditionCategory, { Value, ConditionCategory } from '@/shared/model/conditionCategory';
import { AxiosResponse } from 'axios';
import i18n from '@/i18n';
// import { CONST } from '../utils/Constants';

const logger = new Logger('actions.conditionCategorys');
export const actions: ActionTree<ConditionCategoryState, RootState> = {
  getConditionCategorys({ commit, dispatch, getters, rootGetters }, payload?: { searchParams?: any }) {
    commit('setConditionCategorysIsLoading', true);
    let searchParams = payload?.searchParams ?? getters.getConditionCategorysSearchParams;
    // let organisationId = rootGetters[CONST.getOrganisation].id;
    return defaultBackendConditionCategory
      .getConditionCategorys(searchParams)
      .then((response: AxiosResponse<Value>) => {
        commit('setConditionCategorys', response.data);
        commit('setConditionCategorysIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setConditionCategorysIsLoading', false);
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getConditionCategory({ commit, dispatch }, id: string) {
    return defaultBackendConditionCategory
      .getConditionCategory(id)
      .then((response: AxiosResponse<ConditionCategory>) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  updateConditionCategory({ commit, dispatch }, file: ConditionCategory) {
    return defaultBackendConditionCategory
      .updateConditionCategory(file)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: ConditionCategory;
          }>
        ) => {
          module_utils.ok(i18n.tc(`success.conditionCategory_update`), commit);
          return response.data;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  deleteConditionCategory({ commit, dispatch }, id: string) {
    return defaultBackendConditionCategory
      .deleteConditionCategory(id)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: ConditionCategory;
          }>
        ) => {
          return response;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
};
